import Bonuscalculator from './views/Bonuscalculator';

function App() {
  return (
    <Bonuscalculator />
  );
}

export default App;
